import React from 'react';
import { Icon } from '@iconify/react';
import style from '../../scss/table.module.scss';

/**
 * Lightweight pagination control used by TableComponent.
 *
 * @param {number} page         Current page (1-based).
 * @param {number} totalPages   Total amount of pages.
 * @param {(page:number)=>void} onPageChange  Callback fired with the new page.
 * @param {string} label        Text shown before the page number ("Page").
 */
const TablePagination = ({ page = 1, totalPages = 1, onPageChange = () => {}, label = 'Page' }) => {
    const go = (target) => {
        const next = Math.min(Math.max(target, 1), totalPages);
        if (next !== page) onPageChange(next);
    };

    const isFirst = page <= 1;
    const isLast = page >= totalPages;

    return (
        <div className={style.pagination}>
            <button type="button" className={style.pageBtn} onClick={() => go(1)} disabled={isFirst} aria-label="First page">
                <Icon icon="mdi:chevron-double-left" />
            </button>
            <button type="button" className={style.pageBtn} onClick={() => go(page - 1)} disabled={isFirst} aria-label="Previous page">
                <Icon icon="mdi:chevron-left" />
            </button>

            <span className={style.pageInfo}>
                {label} <span className={style.pageNumber}>{page}</span>
            </span>

            <button type="button" className={style.pageBtn} onClick={() => go(page + 1)} disabled={isLast} aria-label="Next page">
                <Icon icon="mdi:chevron-right" />
            </button>
            <button type="button" className={style.pageBtn} onClick={() => go(totalPages)} disabled={isLast} aria-label="Last page">
                <Icon icon="mdi:chevron-double-right" />
            </button>
        </div>
    );
};

export default TablePagination;
